/* Vuex store, for centralized state management */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import client from 'api-client';

let genericErrorMessage = 'Generic error';

export default new Vuex.Store({
  state: {
    challengeLoading: false,
    challengeManagerOpened: false,
    currentChallenge: 'init',
    findUserInput: null,
    findUserError: null,
    findUserLoading: false,
    verifyEmailErrorMsg: null,
    verifyEmailLoading: false,
    resetPasswordLoading: false,
    passwordChanged: false
  },
  mutations: {
    setChallengeManagerOpened(state, value) {
      state.challengeManagerOpened = value;
    },
    resetFields(state) {
      state.challengeLoading = true;
      state.currentChallenge = 'init';
      state.passwordChanged = false;
      state.challengeManagerOpened = true;
      state.findUserError = null;
      state.verifyEmailErrorMsg = null;
      state.passwordChanged = false;
    },
    setCurrentChallenge(state, value) {
      state.currentChallenge = value;
    },
    setStateChallengeLoading(state, value) {
      state.challengeLoading = value;
    },
    setFindUserLoading(state, value) {
      state.findUserLoading = value;
    },
    setFindUserError(state, value) {
      state.findUserError = value;
    },
    setVerifyEmailErrorMsg(state, value) {
      state.verifyEmailErrorMsg = value;
    },
    setVerifyEmailLoading(state, value) {
      state.verifyEmailLoading = value;
    },
    setResetPasswordLoading(state, value) {
      state.resetPasswordLoading = value;
    },
    setPasswordChanged(state, value) {
      state.passwordChanged = value;
    }
  },
  actions: {
    initChallenge({ commit, dispatch }) {
      commit('resetFields');
      client.initChallenge()
        .then(() => {
          dispatch('loadNextChallenge').then(() => {});
        });
    },
    loadNextChallenge({ commit }) {
      commit('setChallengeManagerOpened', true);
      client.getChallenge()
        .then(challengeId => {
          commit('setCurrentChallenge', challengeId);
        })
        .finally(() => commit('setStateChallengeLoading', false));
    },
    findUser({ commit, dispatch }, uid) {
      commit('setFindUserLoading', true);
      commit('setFindUserError', null);
      client.findUserChallenge(uid)
        .then(res => {
          if (res.outcome === 'success') {
            dispatch('loadNextChallenge');
          } else {
            commit('setFindUserError', res.message || genericErrorMessage);
          }
        })
        .finally(() => commit('setFindUserLoading', false));
    },
    verifyEmail({ commit, dispatch }, token) {
      commit('setCurrentChallenge', 'verify_email');
      commit('setVerifyEmailErrorMsg', null);
      commit('setVerifyEmailLoading', true);
      client.verifyEmailChallenge(token)
        .then(res => {
          if (res.outcome === 'success') {
            dispatch('loadNextChallenge');
          } else {
            commit('setVerifyEmailErrorMsg', res.message || genericErrorMessage);
          }
        })
        .finally(() => commit('setVerifyEmailLoading', false));
    },
    resetPassword({ commit, dispatch }, newPassword) {
      commit('setResetPasswordLoading', true);
      client.passwdChallenge(newPassword)
        .then(res => {
          if (res.outcome === 'success') {
            commit('setPasswordChanged', true);
          } else {
            // TODO
          }
        })
        .finally(() => commit('setResetPasswordLoading', false));
    }
  }
});
